import React from "react";
import { Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import { ProtectedRoute } from "./privateRoute";
import VerifyQuote from "../Pages/verifyQuote";
import { ApproveQuote } from "../Pages/wizard/ApproveQuote";
import ErrorPage from "../Pages/wizard/ErrorPage";
import { OffLine } from "../Pages/wizard/OffLine";
import ListAprovations from "../Pages/listAprovations";

function NestedRoutersAprovations({ path }) {
  const channel = useSelector((state) => state.login.channel);
  const granted = useSelector((state) => state.login.granted);

  return (
    <Switch>
      <ProtectedRoute
        exact
        path={path}
        component={ListAprovations}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/verificacion"}
        component={VerifyQuote}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/aprobacion"}
        component={ApproveQuote}
        channel={channel}
        granted={granted}
      />

      <ProtectedRoute
        exact
        path={path + "/error-simulacion"}
        component={ErrorPage}
        channel={channel}
        granted={granted}
      />
      <ProtectedRoute
        exact
        path={path + "/sin-conexion"}
        component={OffLine}
        channel={channel}
        granted={granted}
      />
    </Switch>
  );
}

export default NestedRoutersAprovations;
